module.exports = __webpack_public_path__ + "static/media/full-stack-developer.d87e7cf3.png";